import { BaseEditor } from "@/libs/map-draw/controllers";

export class EditorController extends BaseEditor {
  constructor(parent) {
    super(parent);
    this.parent = parent;
    this.mapgl = parent.mapgl;
    this.$store = parent.$store;
  }

  // toggle editor off
  toggleEditorOn() {
    console.log("toggle editor on");
  }

  toggleEditorOff() {
    console.log("toggle editor off");
  }
}
